import { Camera, KeyRound, Orbit, Snowflake } from "lucide-react";

export const ICON_MAP = {
  camera: Camera,
  key: KeyRound,
  orbit: Orbit,
  snowflake: Snowflake,
};

export const ICON_OPTIONS = [
  { value: "camera", label: "Cámara (Cabina de fotos)" },
  { value: "key", label: "Llavero (Cabina + llaveros)" },
  { value: "orbit", label: "Órbita (Video 360°)" },
  { value: "snowflake", label: "Copo de nieve (Snow 360)" },
];

/** Valores de ?paquete= que ya entiende el cotizador público (ver App.js, useEffect de autoselección). */
export const COTIZAR_TARGET_OPTIONS = [
  { value: "none", label: "Ninguno (abre el cotizador sin preseleccionar)" },
  { value: "cabina_2", label: "Cabina 2 horas" },
  { value: "cabina_3", label: "Cabina 3 horas" },
  { value: "cabina_llaveros", label: "Cabina + llaveros" },
  { value: "video360", label: "Video 360°" },
  { value: "video360_nieve", label: "Video 360° con nieve / Snow 360" },
];

export const cotizarUrl = (target) => (target ? `/cotizador?paquete=${target}` : "/cotizador");

export const emptyBlock = () => ({
  id: `bloque-${Date.now()}`,
  titulo: "Nuevo servicio",
  subtitulo: "",
  texto: "",
  puntos: [],
  espacio_requerido: "",
  requisitos: [],
  media: [],
  visible: false,
  cotizar_target: "",
  icono: "camera",
});
